import React from 'react';
import { Text404, Text } from './style';


function x404() {
    return (
        <>
            <Text404>
                404
            </Text404>
            <Text>
                Página não encontrada
            </Text>
        </>
    )
}

export default x404;